/* unplugin-vue-components disabled */import { render } from "./PageSearch.vue?vue&type=template&id=2a9aaf2f&scoped=true"
const script = {}

import "./PageSearch.vue?vue&type=style&index=0&id=2a9aaf2f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9aaf2f"]])

export default __exports__